import { hasValue, email } from 'common/validations/field';
import i18n from 'i18n';

// OJO: el login NO valida el FORMATO de la contraseña a propósito: las cuentas
// creadas antes de la política nueva (símbolo obligatorio) deben poder entrar.
// La política se aplica solo donde se CREA una contraseña (registro/reset/update).
const validateLoginForm = (values) => {
  const errors = {};

  if (!email(values.username)) {
    errors.username = i18n.t('email', { ns: 'validations' });
  }

  if (!hasValue(values.password)) {
    errors.password = i18n.t('emptyField', { ns: 'validations' });
  }

  return errors;
};

export default validateLoginForm;
